//modules
import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import LoadingScreen from './components/globalComponents/LoadingScreen';
import { useLoaderFlag } from './components/globalComponents/useLoaderFlag';
import { useTextAnimation } from './components/globalComponents/UseTextAnimation';

//components
import { ProjectCard } from './components/heroSection/ProjectCard';
import { HeroNavigationBar } from './components/heroSection/HeroNavigation';
import { HeroImageProvider } from './components/heroSection/HeroImageContext';
import HeroImage, { HeroContent } from './components/heroSection/HeroImage';
import { RightsFooter } from './components/globalComponents/RightsFooter';
import { useTransition } from './components/globalComponents/PageTransitionContext';

//styles
import './style.css';
import './components/heroSection/HeroPage.css';


function App() {
  const { showLoader, markAsLoaded, isLoaded } = useLoaderFlag();
  const { headingRef, bodyRef } = useTextAnimation(isLoaded);
  const { handleNavigation } = useTransition();


  // projects content
  const ProjectCardContent = ({ onNavigate, isLoaded }) => {
    const projectCardData = [
      { title: "Figma To Code", subtitle: "Product, UI/UX", description: "Bridging design and engineering for a major entertainment platform.", number: "001_", imageUrl: "/images/project_1.webp", path: "/Projects/FigmaToCode" },
      { title: "Unity Design System", subtitle: "Design System", description: "Unifying a fragmented product ecosystem for a benefits company.", number: "002_", imageUrl: "/images/project_3.webp", path: "/Projects/DesignSystem" },
      { title: "Vintage Marketplace", subtitle: "Branding, UI/UX", description: "Designing a second-hand fashion marketplace from the ground up.", number: "003_", imageUrl: "/images/project_4.webp", path: "/Projects/Vintach" },
      { title: "Ticketing Ecosystem", subtitle: "Product, UI/UX", description: "End-to-end design for a white-label event ticketing platform.", number: "004_", imageUrl: "/images/project_2.webp", path: "/Projects/Ticketing" },
    ];

    return (
      <div>
        {projectCardData.map((data, index) => (
          <ProjectCard key={index} {...data} className="projectCard" onNavigate={onNavigate} index={index} isLoaded={isLoaded} />
        ))}
      </div>
    );
  };

  return (
    <HelmetProvider>

      <Helmet>
      <title>Valentina García Aiello</title>
      <meta name="description" content="Senior product designer and illustrator based in Uruguay — crafting digital products that think, and visuals that feel." />

      <meta property="og:title" content="Valentina García Aiello" />
      <meta property="og:description" content="Senior product designer and illustrator based in Uruguay — crafting digital products that think, and visuals that feel." />
      <meta property="og:image" content="https://valentinagarcia.design/images/preview.png" />
      <meta property="og:url" content="https://valentinagarcia.design" />
      <meta property="og:type" content="website" />
      
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Valentina García Aiello" />
      <meta name="twitter:description" content="Senior product designer and illustrator based in Uruguay — crafting digital products that think, and visuals that feel." />
      <meta name="twitter:image" content="https://valentinagarcia.design/images/preview.png" />
    </Helmet>

      <div className="app-container">
        {showLoader && <LoadingScreen onComplete={markAsLoaded} />}
        <HeroImageProvider>
          <div className="hero-page">
            <div className="hero-top-section">
              <div className="hero-subtitle">
                <p className="heading-3 intro-text" ref={headingRef}> Hello. Hola. Ciao.</p>
                <p className="body intro-text" ref={el => bodyRef.current[0] = el}> I'm Valentina, senior product designer and illustrator —</p>
              </div>
              <HeroNavigationBar/>
            </div>
            <main>
              <div className="main-container">
                <div className="image-section">
                  <HeroImage isLoaded={isLoaded}/>
                  <HeroContent isLoaded={isLoaded} />
                </div>

                <div className="projects-section">
                    <div className="hero-intro">
                      <p className="subtitle hero-projects-label" ref={el => bodyRef.current[1] = el}> /Projects </p>
                  </div>
                  <section className="projects-container">
                    <div>
                      <ProjectCardContent onNavigate={handleNavigation} isLoaded={isLoaded} /> 
                    </div>
                  </section>
                </div>
              </div>
            </main>
            <RightsFooter customClass= "hero-class" />
          </div>
        </HeroImageProvider>
      </div>
     </HelmetProvider>
  );
}


export default App;
